<template>
  <Link
    :href="href"
    :class="classes"
  >
    <slot />
  </Link>
</template>

<script>
import  { Link } from '@inertiajs/vue3'
export default {
    components: {
        Link
    },
  props: ['href', 'active'],

  computed: {
    classes() {
      return this.active
        ? 'border-primary text-primary whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
        : 'border-transparent text-font-light hover:border-font-lightest hover:text-font-dark whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm';
    },
  },
};
</script>
